export default {
  // Nav
  'nav.home': 'Home',
  'nav.guide': 'Guide',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.categories': 'Categories',
  'nav.safety': 'Safety',
  'nav.brand': 'USFans Spreadsheet',

  // Hero
  'hero.eyebrow': 'THE USFANS SPREADSHEET RESOURCE HUB',
  'hero.title': 'USFans Spreadsheet — Find, Organize & Explore Creator Information',
  'hero.subtitle':
    'Discover practical USFans spreadsheet resources, creator guides, comparisons, safety information and helpful tools designed to make creator research faster, clearer and easier to organize.',
  'hero.ctaPrimary': 'usfans spreadsheet',
  'hero.ctaSecondary': 'buy it now',
  'hero.trust': 'Independent resource · Practical guides · Safety-focused · Regularly updated',

  // Category section
  'category.title': 'Explore by Category',
  'category.subtitle':
    'Jump straight to the exact section of the store you need. Choose a category below or use the dropdown to navigate quickly.',
  'category.dropdownLabel': 'Select a category',
  'category.browseAll': 'Browse the full catalog on the store',
  'category.featured': 'Popular categories',

  // What is section
  'what.title': 'What Is a USFans Spreadsheet?',
  'what.p1':
    'A USFans spreadsheet is a structured way to organize creator-related information in one place. Instead of searching through scattered pages, users can use organized spreadsheet-style resources to research, compare and manage information more efficiently.',
  'what.p2':
    'Our USFans Spreadsheet Resource Hub brings together practical guides, comparisons, safety resources and educational content to help users understand how these resources work and how to use them responsibly.',
  'what.cta': 'Explore the USFans Spreadsheet Guide',

  // Benefits
  'benefit.title': 'Why Use a USFans Spreadsheet?',
  'benefit.subtitle': 'Practical advantages that make organized research simpler and more reliable.',
  'benefit.1.title': 'Organized Research',
  'benefit.1.desc': 'Keep relevant creator information structured and easier to review.',
  'benefit.2.title': 'Faster Discovery',
  'benefit.2.desc': 'Use organized resources instead of relying entirely on scattered searches.',
  'benefit.3.title': 'Easier Comparison',
  'benefit.3.desc': 'Compare different information sources with clear tables and structured guides.',
  'benefit.4.title': 'Better Decision Making',
  'benefit.4.desc': 'Understand what information means before relying on it.',

  // Articles
  'articles.title': 'Latest USFans Spreadsheet Guides',
  'articles.subtitle':
    'Original, practical guides to help you understand, organize and use spreadsheet resources safely.',
  'articles.readTime': '{{minutes}} min read',
  'articles.updated': 'Updated',
  'articles.readMore': 'Read article',
  'articles.related': 'Related Guides',

  // Comparison
  'comparison.title': 'USFans Spreadsheet vs Other Discovery Methods',
  'comparison.subtitle': 'See how organized spreadsheet resources compare to other ways of researching.',
  'comparison.method': 'Method',
  'comparison.organization': 'Organization',
  'comparison.searchability': 'Searchability',
  'comparison.compare': 'Comparison',
  'comparison.bestFor': 'Best For',
  'comparison.row1.name': 'USFans Spreadsheet',
  'comparison.row2.name': 'Manual Search',
  'comparison.row3.name': 'Creator Directory',
  'comparison.row4.name': 'Unstructured Lists',
  'comparison.high': 'High',
  'comparison.medium': 'Medium',
  'comparison.low': 'Low',
  'comparison.row1.best': 'Organized research',
  'comparison.row2.best': 'Quick searches',
  'comparison.row3.best': 'Browsing',
  'comparison.row4.best': 'Basic reference',
  'comparison.cta': 'See the Full Comparison',

  // Safety
  'safety.title': 'Stay Safe When Using Online Spreadsheet Resources',
  'safety.subtitle': 'A few simple habits protect your data and your peace of mind.',
  'safety.p1':
    'Never share passwords or sensitive information with unknown websites. Verify links before opening them, avoid suspicious downloads and treat unverified creator lists or spreadsheet claims cautiously.',
  'safety.1': 'Verify links before clicking',
  'safety.2': 'Never share passwords',
  'safety.3': 'Avoid suspicious downloads',
  'safety.4': 'Question unverified claims',
  'safety.cta': 'Visit the Safety Center',

  // Final CTA
  'final.title': 'Ready to Explore USFans Spreadsheet Resources?',
  'final.subtitle':
    'Start with the complete USFans Spreadsheet guide, then explore creator resources, comparisons and safety information designed to make your research more organized.',
  'final.cta': 'Explore USFans Spreadsheet',

  // Footer
  'footer.tagline':
    'An independent informational resource for USFans spreadsheet guides, comparisons and safety information.',
  'footer.resources': 'Resources',
  'footer.explore': 'Explore',
  'footer.legal': 'Legal',
  'footer.disclaimer':
    'USFanslink.makeup is an independent informational resource. Information may change, third-party websites may change their policies, and users should verify important information independently.',
  'footer.rights': 'All rights reserved.',
  'footer.store': 'Visit the store',

  // Categories
  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies/Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants/Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear/Underpants',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',
};